import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";

import { BsDatepickerModule, BsDropdownModule } from "ngx-bootstrap";
import { SelectModule } from "ng2-select";

import { CallsComponent } from "./calls.component";
import { CallListModule } from "../../components/call/list/call-list.module";

@NgModule({
  declarations: [
    CallsComponent
  ],
  exports: [
    CallsComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    CallListModule,
    BsDatepickerModule,
    BsDropdownModule,
    SelectModule
  ]
})
export class CallsModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/call/list/calls.module.ts